// @ts-nocheck
import React, { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import Breadcrumb from '../breadcrumb/breadcrumb';
import { Settings } from './Settings';
import { useTranslation } from '../../i18n/LanguageContext';

const AccountSettings = () => {
  const { t } = useTranslation();
  const [role, setRole] = useState('');
  const pages = [{ name: role === 'admin' ? t('settings.adminBreadcrumb') : t('settings.managerBreadcrumb'), href: '/admin/geral', current: true }]

  useEffect(() => {
    const token = sessionStorage.getItem('jwt');
    if (token) {
      const decoded = jwtDecode(token);
      const userRole = decoded.authorities[0].authority.toLowerCase();
      setRole(userRole);
    }
  }, []);

  return (
    <>
      <div className="mx-5 pb-10 sm:mx-8 lg:mx-10">
        <div className="flex justify-between">
          <Breadcrumb pages={pages} />
        </div>

        <div className="mt-10 max-w-4xl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-green-cl">{t('settings.accountInfo')}</p>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">{t('settings.title')}</h1>
        <p className="mt-3 text-sm leading-6 text-gray-500 sm:text-base">
          {t('settings.descriptionBefore')} <strong className="text-black">{t('settings.descriptionStrong')}</strong>, {t('settings.descriptionAfter')}
        </p>
        </div>
       
          {/* <AdminInfo />
          <Password /> */}
          <Settings />
         </div>
    </>
  );
};

export default AccountSettings;
